var React = require('react');

function ThinX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.692 2.7951C15.1027 2.38445 15.1027 1.71865 14.692 1.30799C14.2814 0.897338 13.6155 0.897337 13.2049 1.30799L8 6.51289L2.7951 1.30799C2.38445 0.897337 1.71865 0.897336 1.30799 1.30799C0.897337 1.71865 0.897338 2.38445 1.30799 2.7951L6.51289 8L1.30799 13.2049C0.897336 13.6156 0.897336 14.2814 1.30799 14.692C1.71865 15.1027 2.38445 15.1027 2.7951 14.692L8 9.48711L13.2049 14.692C13.6155 15.1027 14.2814 15.1027 14.692 14.692C15.1027 14.2814 15.1027 13.6156 14.692 13.2049L9.48711 8L14.692 2.7951Z","fill":"#1B1B1B"}));
}

ThinX.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ThinX;

ThinX.default = ThinX;
